import React, { useEffect, useState } from 'react'
import classes from "../../styles.module.css";
import { useNavigate } from 'react-router-dom';
import TitleSection from '../../../../common/TitleSection';
import { Helmet } from 'react-helmet';
import { FullWidthWiraaAds } from '../../../../common/Ads/FullWidthWiraaAds';
import styles from "../../../../ContentStyling.module.css";

const FeettoKm = () => {
    const [inputValue, setInputValue] = useState();
    const [outputValue, setOutputValue] = useState();
    const [errorMessage, setErrorMessage] = useState();
    const navigate = useNavigate();

    useEffect(() => {
        // Initialize Google Ads
        try {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
          console.error("AdSense run successfully");
        } catch (e) {
          console.error("AdSense error", e);
        }
      }, []);

      const convertFeetToKm = () => {
        // Validate input: allow numbers, decimals, and optional minus sign
        if (!/^-?\d+(\.\d+)?$/.test(inputValue)) {
            setErrorMessage("Please enter a valid length in feet (e.g., 3280.84, 5000).");
            setOutputValue("");
            return;
        }

        setErrorMessage("");
        const feetValue = parseFloat(inputValue); // Convert input string to a number
        const kmValue = feetValue * 0.0003048; // 1 foot = 0.0003048 kilometers
        setOutputValue(kmValue.toFixed(6)); // Limit output to 6 decimal places
    };






      const handleClearBtn = () => {
        setInputValue("");
        setOutputValue("");
        setErrorMessage("");
      }

      const handleSwapClick = () => {
        navigate("/converters/km-to-feet");
    };

        

  return (
    <div className={classes.page}>
      <Helmet>
                <title>Feet to KM Converter - Wiraa tools</title>
                <meta name="description" content="Easily convert feet to km using our online conversion tool. Accurate results with simple calculations for your length measurements. Try now!" />
        </Helmet>
    <div className={classes.container}>
       <TitleSection
                    icon="https://cdn-icons-png.flaticon.com/128/570/570968.png"
                    title="Feet To KM Converter"
                    subTitle="Effortlessly Convert Feet To KM for Accurate Measurements"
                  />
      <div className={classes.innerCon}>
        <div className={classes.inputCon}>
            <p className={classes.inputplaceholder}>Feet Value</p>
            <input value={inputValue} onChange={(e) => setInputValue(e.target.value)} className={classes.inputfield} placeholder='Enter feet value'/>
            {errorMessage && <p className={classes.errorMsg}>{errorMessage}</p>}
        </div>
        <div className={classes.btnCon}>
            <button className={classes.convertBtn} onClick={convertFeetToKm}>Convert</button>
            <button className={classes.clearBtn} onClick={handleClearBtn}>Clear</button>
            <button className={classes.swapBtn} onClick={handleSwapClick}>Swap</button>
        </div>
        <div className={classes.outputCon}>
            <p className={classes.outputplaceholder}>KM Value</p>
            <p className={classes.outputfield}>{outputValue}</p>
        </div>
      </div>
      <div className={classes.ads}>
        <FullWidthWiraaAds/>
     </div>
     <div className={styles.contentContainer}>
      <p>For engineers, surveyors, travellers, and students, the Feet to Kilometres Converter is a powerful tool that helps you convert distances from feet (ft) to kilometers (km) with accuracy and ease. This is especially helpful for working across imperial and metric systems in global projects.</p>
      <p>Whether you’re mapping land, working with elevation data, or tracking large distances, this converter simplifies the conversion process.</p>
      <h3>What Are Feet and Kilometres?</h3>
      <p><b>Feet (ft): </b>A unit of length in the imperial system. Commonly used in the U.S. for measuring elevation, height, or shorter distances. <br />  1 foot = 0.3048 meters</p>
      <p><b>Kilometres (km): </b> A metric unit of length used for measuring longer distances such as roads, routes, and geographic spans. <br />  1 kilometer = 1,000 meters</p>
      <h3>Why Convert Feet to Kilometers?</h3>
      <ul>
        <li><b>Global Standards:</b> Kilometers are used in most countries and scientific fields.</li>
        <li><b>Mapping & Surveying:</b> Needed when converting local height data into scalable formats.</li>
        <li><b>Travel & Navigation:</b> Convert elevation or terrain measurements for use in metric-based tools and maps.</li>
      </ul>
      <h3>How to Use the Feet to Kilometers Converter</h3>
      <ol>
        <li><b>Input Feet Value:</b> Type the number of feet into the converter field.</li>
        <li><b>Click Convert:</b> The tool instantly shows the value in kilometers.</li>
        <li><b>Copy the Result:</b> Use it in your reports, maps, or data sheets.</li>
      </ol>
      <h3>Conversion Examples:</h3>
      <ul>
        <li>1 ft → 0.0003048 km</li>
        <li>1,000 ft → 0.3048 km</li>
        <li>5,280 ft (1 mile) → 1.6093 km</li>
        <li>10,000 ft → 3.048 km</li>
      </ul>
      <h3>Benefits of Using Feet to Kilometres Converter</h3>
      <ul>
        <li><b>Accurate & Reliable:</b> Uses the exact standard conversion formula.</li>
        <li><b>Time-Saving:</b> No manual calculations needed.</li>
        <li><b>User-Friendly:</b> Ideal for both technical professionals and students.</li>
      </ul>
      <h3>Why Choose This Converter?</h3>
      <p>This converter is built to serve the needs of professionals and learners alike. It’s especially useful for:</p>
      <ul>
        <li><b>Surveyors & Civil Engineers:</b> To convert elevation and land data.</li>
        <li><b>Outdoor Enthusiasts:</b> For tracking hiking trails or mountain heights.</li>
        <li><b>Students & Teachers:</b> To learn metric and imperial conversions clearly.</li>
      </ul>
     </div>
    </div>
   </div>
  )
}

export default FeettoKm;
